module.exports = __webpack_public_path__ + "static/media/video-hand.a31baa51.svg";